/**
 * A step attribute is already described by the action when the action defines the same key, or a
 * parent on its dotted path (`items` covers `items.sku`, `a.b` covers `a.b.c`). Parents are matched
 * on whole path segments, so `item` does not cover `items.sku`.
 */
const isAttributeKeyCoveredByAction = (key, actionAttributeKeys) => {
  if (actionAttributeKeys.has(key)) {
    return true;
  }

  if (typeof key !== 'string' || key === '') {
    return false;
  }

  const parts = key.split('.');
  let parentKey = '';
  for (let index = 0; index < parts.length - 1; index += 1) {
    parentKey = index === 0 ? parts[0] : `${parentKey}.${parts[index]}`;
    if (parentKey !== '' && actionAttributeKeys.has(parentKey)) {
      return true;
    }
  }

  return false;
};

export default isAttributeKeyCoveredByAction;
